module.exports = (__webpack_require__("981n"))(71);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/vuex-router-sync/index.js from dll-reference vue_dll
// module id = 9JMe
// module chunks = 0